import { Injectable } from "@angular/core";
import type { Resolve } from "@angular/router";
import { NodeSharedFacade } from '@medsurf/flat-facades';
import { delay, firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ElearningViewerResolver implements Resolve<void> {

  public constructor(protected nodeSharedFacade: NodeSharedFacade) {}

  public async resolve() {
    // Delay is needed to wait for state to be updated
    await firstValueFrom(this.nodeSharedFacade.requestElearnings().pipe(delay(1)));
    const elearnings = this.nodeSharedFacade.snapshot_elearnings();
    elearnings.forEach((n) => {
      if (n.hidden) return;
      this.nodeSharedFacade.requestNodesByParentId(n.id);
    })
    return;
  }
}